import React, { createContext, useContext, useReducer } from "react";
import { initialState, filasEsperaReducer, FilasEsperaState } from "./filas-espera-reducer";

type FilasEsperaContextType = {
    state: FilasEsperaState;
    dispatch: React.Dispatch<any>;
};

const FilasEsperaContext = createContext<FilasEsperaContextType | undefined>(undefined);

export const FilasEsperaProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(filasEsperaReducer, initialState);

    return (
        <FilasEsperaContext.Provider value={{ state, dispatch }}>
            {children}
        </FilasEsperaContext.Provider>
    );
};

export const useFilasEsperaState = () => {
    const context = useContext(FilasEsperaContext);
    if (!context) {
        throw new Error("useFilasEsperaState must be used within FilasEsperaProvider");
    }
    return context.state;
};

export const useFilasEsperaDispatch = () => {
    const context = useContext(FilasEsperaContext);
    if (!context) {
        throw new Error("useFilasEsperaDispatch must be used within FilasEsperaProvider");
    }
    return context.dispatch;
};
